import type { IInfraAddress } from "@/features/servers/schemas/servers";

/** Formatea dirección de ficha infra (no perfil). */
export function formatInfraAddress(
  address: IInfraAddress | null | undefined
): string | null {
  if (!address) return null;
  const label = [
    address.street,
    address.city,
    address.state,
    address.zip,
    address.country,
  ]
    .map((p) => p?.trim())
    .filter(Boolean)
    .join(", ");
  return label || null;
}
